import * as React from "react";

export function SilverCoin(): JSX.Element {
  return (
    <i className="fa fa-circle text-slate-400" aria-hidden="true"></i>
  );
}
